import { _ } from '/@/locale';
import Alert from '../bayer/alert';

const PrivacyBar = ({ message = _('Contenido para uso interno, no difundir.'), className = {} }) => {
    return <Alert severity='danger'>{message}</Alert>;
};

export default PrivacyBar;
